"use client"

import { useTranslations } from 'next-intl'
import { X, Share, PlusSquare } from 'lucide-react'

interface Props {
  open: boolean
  onClose: () => void
}

export function IosInstallGuide({ open, onClose }: Props) {
  const t = useTranslations('pwa.install.iosGuide')

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[1000] flex items-end sm:items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-md bg-panel rounded-2xl overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b border-base">
          <h3 className="text-base font-semibold">{t('title')}</h3>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-card">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-accent/10 text-accent flex items-center justify-center shrink-0 text-sm font-semibold">1</div>
            <div>
              <p className="text-sm">{t('step1.text')}</p>
              <div className="flex items-center gap-1.5 mt-1 text-xs text-muted">
                <Share className="w-4 h-4" /> {t('step1.hint')}
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-accent/10 text-accent flex items-center justify-center shrink-0 text-sm font-semibold">2</div>
            <div>
              <p className="text-sm">{t('step2.text')}</p>
              <div className="flex items-center gap-1.5 mt-1 text-xs text-muted">
                <PlusSquare className="w-4 h-4" /> {t('step2.hint')}
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-accent/10 text-accent flex items-center justify-center shrink-0 text-sm font-semibold">3</div>
            <p className="text-sm">{t('step3.text')}</p>
          </div>
        </div>

        <div className="p-4 border-t border-base">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg bg-accent text-white text-sm font-medium hover:opacity-90 transition"
          >
            {t('done')}
          </button>
        </div>
      </div>
    </div>
  )
}